import React, { useState } from 'react';
import { Redirect } from "react-router-dom";

import seasonIcon from './../assets/images/icono-Estacion-Blanco.svg';

//props.season.thumbnail en vz de cover 

const Season = (props) => {
  const [goToSeason, setGoToSeason] = useState();

  if (goToSeason) {
    return (<Redirect to={`/seasons/${props.season._id}`} push/>)
  }

  return (
    <div 
      onClick={() => setGoToSeason(props.season._id)}
    >
      <div 
        className="caja-imagen caja-imagen__estacion caja-imagen__bg-estacion"
        style={{
          backgroundImage: `url("${props.season.thumbnail}")`,
        }}
      >
        <span class="caja-imagen__texto text-center">
          <span class="caja-imagen__icono">
            <img src={seasonIcon} alt=""/>
          </span> {props.season.name}
        </span>
      </div>
    </div>
  );
};

export default Season;
